<template>
    <textarea ref="textarea">{{value}}</textarea>
</template>

<script>
    var tinymce = require('tinymce');
    require('tinymce/plugins/code/plugin.js');
    require('tinymce/plugins/media/plugin.js');
    require('tinymce/plugins/image/plugin.js');
    require('tinymce/plugins/table/plugin.js');
    require('tinymce/plugins/lists/plugin.js');
    require('tinymce/plugins/link/plugin.js');
    require('tinymce/plugins/paste/plugin.js');
    require('tinymce/themes/modern/theme');
    require('tinymce/skins/lightgray/skin.min.css');

    export default {
        props: ['value','colorfont'],
        mounted: function(){
            var self = this;

            tinymce.init({
                target: this.$refs.textarea,
                height: 100,
                skin: false,
                menubar: false,
                entity_encoding : "raw",
                plugins: 'code image media table lists link paste',
                toolbar: 'bold italic | bullist numlist outdent indent | link unlink | code',
                paste_as_text: true,
                extended_valid_elements: "a[href|target|onclick|title]",
                content_css: '/css/app.css',
                content_style: "body{background: white; color: #272727; padding: 20px;}" , 
                spellchecker_language: 'es',
                setup: function (editor) 
                {
                    editor.on('change', function () {
                        self.$emit('input', editor.getContent().replace(/<a href=/gi,'<a style="color:' +  self.colorfont + '!important" href='));
                    });
                }
            });
        }
    }
</script>